import { defineMessages } from 'react-intl'

const scope = `procurify.components.StatusCardLegacyCollapsibleToggle`

export default defineMessages({
  hideLabel: {
    id: `${scope}.hideLabel`,
    defaultMessage: 'Hide',
  },
  showLabel: {
    id: `${scope}.showLabel`,
    defaultMessage: 'Show',
  },
})
